import { create } from 'zustand';
import { createChecklistSlice } from './checklistSlice';
import { createSearchSlice } from './searchSlice';
import { createSelectionSlice } from './selectionSlice';
import { createValidationSlice } from './validationSlice';
export const useChecklistView = create()((...a) => (Object.assign(Object.assign(Object.assign(Object.assign({}, createSearchSlice(...a)), createSelectionSlice(...a)), createChecklistSlice(...a)), createValidationSlice(...a))));
